/*
Backup ZIP format — cross-platform contract shared with the Android app.
Mirrors `app/src/main/java/app/arbre/backup/BackupModels.kt`.

Layout inside the ZIP:
    meta.json
    captures.json
    photos/<uuid>.jpg

`schemaVersion` is the only field that gates compatibility:
- The importer refuses anything with schemaVersion > kCurrentSchemaVersion.
- Bumping the version requires shipping a versioned reader path.

Captures are written **without** the IDB-autoincremented `id`, so re-imports
on a different device never collide on primary keys; the dedup key is
(arbreId, timestamp), enforced by the IDB unique index `by_arbre_ts`.
*/

import type { Capture } from '../data/types'

export const kCurrentSchemaVersion: number = 1
export const kMetaFilename: string = 'meta.json'
export const kCapturesFilename: string = 'captures.json'
export const kPhotosDir: string = 'photos/'

export interface BackupMeta
{
	schemaVersion: number
	exportedAt: number
	captureCount: number
	appVersionName: string
	appVersionCode: number
	appPlatform: 'pwa' | 'android'
}

/*
On-disk representation of a capture inside captures.json. The IDB id is
intentionally absent so two backups merging on a third device produce a
deterministic union under the (arbreId, timestamp) dedup key.
*/
export type ExportedCapture = Omit<Capture, 'id'>
